import { MoonIcon, SunIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";
import { useTheme } from "@/hooks/use-theme";
import useCustomTranslation from "../hooks/use-custom-translation";

export function ThemeSwitcher() {
  const { setTheme, theme } = useTheme();
  const { t } = useCustomTranslation();
  return (
    <TooltipProvider disableHoverableContent>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <Button
            className="size-8 rounded-full bg-background mr-2 cursor-pointer"
            variant="outline"
            size="icon"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          >
            <SunIcon className="size-3 rotate-90 scale-0 transition-transform ease-in-out duration-500 dark:rotate-0 dark:scale-100" />
            <MoonIcon className="absolute size-3 rotate-0 scale-100 transition-transform ease-in-out duration-500 dark:-rotate-90 dark:scale-0" />
            <span className="sr-only">{t("switchTheme.switch")}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{t("switchTheme.switch")}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
